var exports = {
  "Kd": "ReportSpaceContainer__FtCMEK",
  "xB": "ReportSpaceHelpText__yHv8Gb",
  "XY": "ReportSpaceSubmitButton__Sv66fj",
  "hi": "ReportSpaceFooterSpacing__luhgvE",
  "xR": "ReportSpaceDialog__qo-TTU",
};

module.exports = exports;
